import { HStack } from '@rbilabs/universal-components';

export const StoreCardActionsContainer = HStack.withConfig({
  justifyContent: 'flex-end',
  marginBottom: '$4',
});
